<template>
    <div id="instantSearchWrapper">
        <div id="searchIcon">
            <i class="fas fa-search"></i>
        </div>
        <input type="text" id="quickSearch" placeholder="Search Makes, Models, or Keywords" autocomplete="off" @blur="closeKeyboard" @input="onTyping" @focus="keyboardCouldOpen"/> 
    </div>
</template>

<script>
    export default {
        data() {
            return {
                debounce: null
            }
        },
        mounted() {
            document.getElementById('quickSearch').value = this.quickSearchText;
        },
        computed: {
            quickSearchText() {
                return this.$store.getters.getSearchText;
            }
        },
        watch: {
            quickSearchText(newText, oldText) {
                if(newText != oldText && (newText == "" || !this.debounce)) {
                    document.getElementById('quickSearch').value = this.quickSearchText;
                }
            }
        },
        methods: {
            keyboardCouldOpen() {
                this.$store.commit('updateMobileKeyboradStatus', true);
            },
            onTyping() {
                let searchText = document.getElementById('quickSearch').value;
                this.onChange(searchText);
            },
            onChange(value) {
                this.$store.commit('updateSearchText', value);
                clearTimeout(this.debounce);
                this.debounce = setTimeout(this.commitChangeToQuery, 1000);
            },
            commitChangeToQuery() {
                clearTimeout(this.debounce);
                this.debounce = null;
                let eventLabel = this.$store.getters.isMobile ? 'mobile' : 'pc';
                this.$gtag.event('running', {'event_category': 'instant_search','event_label': eventLabel});
                this.$store.commit('notifySearchQueryChanges', true);
            },
            closeKeyboard() {
                this.$store.commit('updateMobileKeyboradStatus', false);
            }
        }
    }
</script>

<style>
    #instantSearchWrapper {
        width: calc(22 * var(--vw));
        height: inherit;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 6px;
    }

    .inmobile #instantSearchWrapper {
        width: calc(96 * var(--vw));
        border-radius: 5px;
    }

    #quickSearch {
        width: calc(20 * var(--vw));
        border-radius: calc(var(--vratio) * var(--vh));/*5px;*/
        border-top-style: hidden;
        border-right-style: hidden;
        border-left-style: hidden;
        border-bottom-style: groove;
        background-color: #eee;
        outline: none;
        padding: calc(.5 * var(--vh)) calc(.5 * var(--vw)) calc(.5 * var(--vh)) calc(2.5 * var(--vw));
        font-size: inherit;
    }

    .inmobile #quickSearch {
        width: calc(96 * var(--vw));
        padding: calc(.5 * var(--vh)) calc(.5 * var(--vw)) calc(.5 * var(--vh)) calc(3.5 * var(--vh));
        border-radius: 5px;
    }

    .inmobile.tabletstyle .landscape #quickSearch {
        padding:calc(.5 * var(--vh)) calc(.5 * var(--vw)) calc(.5 * var(--vh)) calc(4 * var(--vh));
    }

    #searchIcon {
        width: calc(2 * var(--vw));
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        left: calc(2 * var(--vw));
        color: #757575;
    }

    .inmobile #searchIcon {
        left: calc(2.2 * var(--vh));
    }

    .inmobile.tabletstyle .landscape #searchIcon {
        left: calc(3.2 * var(--vh));
    }
</style>